module.exports = __webpack_public_path__ + "static/media/fenxsIcon.aa8eb7f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fenxsIcon.jpg
// module id = 1755
// module chunks = 0 1